import type { Preferences } from "../types";
import { Sheet } from "./Sheet";

const CATEGORIES = ["US", "World", "Business", "Technology", "Science", "Local", "Culture", "Religion", "Health"];

export function SettingsSheet({ preferences, onChange, onClose }: { preferences: Preferences; onChange: (next: Preferences) => void; onClose: () => void }) {
  const toggleCategory = (category: string) => {
    const included = preferences.categories.includes(category);
    onChange({ ...preferences, categories: included ? preferences.categories.filter((item) => item !== category) : [...preferences.categories, category] });
  };
  return (
    <Sheet title="Settings" onClose={onClose}>
      <p className="sheet-intro">Major stories always remain visible. Your choices only shape the secondary briefing.</p>
      <fieldset className="settings-group">
        <legend>Categories</legend>
        <div className="check-list">
          {CATEGORIES.map((category) => <label key={category}><input type="checkbox" checked={preferences.categories.includes(category)} onChange={() => toggleCategory(category)} /><span>{category}</span></label>)}
        </div>
      </fieldset>
      <div className="settings-group settings-group--rows">
        <label><span><strong>Larger text</strong><small>Increase article and control text.</small></span><input type="checkbox" checked={preferences.largeText} onChange={() => onChange({ ...preferences, largeText: !preferences.largeText })} /></label>
        <label><span><strong>Reduce motion</strong><small>Limit interface transitions.</small></span><input type="checkbox" checked={preferences.reduceMotion} onChange={() => onChange({ ...preferences, reduceMotion: !preferences.reduceMotion })} /></label>
      </div>
    </Sheet>
  );
}
